import { request } from 'shared/helpers/sagas'
import { axiosInstance } from 'network/apis'


export const fetchModeratorAvailability = async (moderatorId, clientId) => {
  return await axiosInstance.get(`MyProxy/moderator/get/${moderatorId}/get-mod-av/${clientId}`, { handlerEnabled: true })
};

export const fetchModeratorImportedAvailability = async (moderatorId, clientId, externalCalendar, key, userId, forceUpdate) => {
  return await axiosInstance.post(`MyProxy/moderator/get/${moderatorId}/imported/${clientId}`, {externalCalendar: externalCalendar, key: key, userId: userId, forceUpdate:forceUpdate}, { handlerEnabled: true })
};

export const unlinkImportModerator = async (moderatorId, clientId) => {
  return await axiosInstance.post(`MyProxy/moderator/unlink-imp-mod/${moderatorId}`, {clientId:clientId}, { handlerEnabled: true })
};

export const updateGoogleSpreadSheet = async () => {
  return await axiosInstance.get(`MyProxy/moderator/update-google-sheet-first-date`,{}, { handlerEnabled: true })
};

export const fetchImportAvailabilityStatus = async (moderatorId) => {
  return await axiosInstance.get(`MyProxy/moderator/get/${moderatorId}/import-status`, { handlerEnabled: true })  
};

export const fetchModeratorAvailabilityForPM = async (clientId, projectsToFilterPM, moderatorsToFilter, filterBy) => {
  let payload = {
    filterBy: filterBy
  }
  if(filterBy === "Projects" && projectsToFilterPM.length!==0) {
    payload.filteredItems = `(${projectsToFilterPM.join(',')})`
  } else if (filterBy === "Moderators" && moderatorsToFilter.length!==0) {
    payload.filteredItems = `(${moderatorsToFilter.join(',')})`
  }
  return await axiosInstance.post(`project_manager/get/availabilities/client/${clientId}`, payload, { handlerEnabled: true })
};

export const postModeratorAvailability = async ({ moderatorId, clientId, payload }) => {
  return await axiosInstance.post(`moderator/post-availability`, { moderatorId: moderatorId, clientId: clientId, startTime: payload.startTime, endTime: payload.endTime }, { handlerEnabled: true })
};

export const fetchTimeSlotsForModerator = async (moderatorId, clientId, projectsToFilter) => {
  console.log("projectsToFilter ", projectsToFilter.join(','))
  let payload = {}
  if(projectsToFilter.length!==0){
    payload = {
      projectsToFilter: `(${projectsToFilter.join(',')})`
    }
  }
  return await axiosInstance.post(`moderator/get/${moderatorId}/client/${clientId}/time_slots`, payload, { handlerEnabled: true })
}

export const fetchTimeSlotsForPM = async (clientId, projectsToFilterPM, moderatorsToFilter, filterBy) => {
  let payload = {
    filterBy: filterBy
  }
  if(filterBy === "Projects" && projectsToFilterPM.length!==0) {
    payload.filteredItems = `(${projectsToFilterPM.join(',')})`
  } else if (filterBy === "Moderators" && moderatorsToFilter.length!==0) {
    payload.filteredItems = `(${moderatorsToFilter.join(',')})`
  }
  return await axiosInstance.post(`project_manager/get/time_slots/client/${clientId}`, payload, { handlerEnabled: true })
}

export const putModeratorAvailability = async (payload) => {
  return axiosInstance.put(`moderator/${payload.id}/update-availability`, { startTime: payload.startTime, endTime: payload.endTime }, { handlerEnabled: true })
};

export const deleteModeratorAvailability = async (id) => {
  return await axiosInstance.delete(`moderator/${id}/delete-availability`, { handlerEnabled: true })
};

export const fetchModeratorsForTimeSlot = async (timeSlotId) => {
  return await axiosInstance.get(`get-moderators-for-timeSlot/${timeSlotId}`, { handlerEnabled: true })
}

export const fetchPossibleModeratorsForTimeSlot = async (timeSlotId) => {
  return await axiosInstance.get(`get-moderators-option/${timeSlotId}`, { handlerEnabled: true })
}

export const fetchConferenceLinkByTimeslotId = async ({ payload }) => {
  return await axiosInstance.get(`get-conf-link-time-slot-id/${payload}`, { handlerEnabled: true })
}

export const deleteModeratorFromProject = async ({ projectId, moderatorId }) => {
  return await axiosInstance.delete(`project/${projectId}/moderator/${moderatorId}`, { handlerEnabled: true })
}

export function postModeratorsForConference(timeSlotId, payload) {
  return request(`/v1/time_slot/${timeSlotId}/moderator`, 'POST', payload)
}

export function deleteModeratorFromConference(timeSlotId, moderatorId) {
  return request(`/v1/time_slot/${timeSlotId}/moderator/${moderatorId}`, 'DELETE')
}

// export function putObservers (observers, timeSlotId) {
//   return request(`/v1/time_slot/${timeSlotId}/observers?lang=en_us`,
//     'PUT',
//     observers
//   )
// }

// export function fetchAvailabilityAndTimeslotsForProject (projectId, moderatorsToFilter) {
//   const moderatorIds = moderatorsToFilter.map(m => `moderatorIds=${m}`)
//   //return request(`/v1/project/${projectId}/availability_and_time_slots?${moderatorIds.join('&')}`)
//   return []
// }

export function fetchAvailabilityForProject(projectId) {
  return request(`/v1/project/${projectId}/availability`)
}

// Project Timeslots — per-project scheduling mode + availability windows
export const fetchProjectAvailability = async (projectId) => {
  return await axiosInstance.get(`project-availability/${projectId}`, { handlerEnabled: true })
}

export const saveProjectAvailability = async (projectId, payload) => {
  return await axiosInstance.post(`project-availability/${projectId}`, { schedulingType: payload.schedulingType, windows: payload.windows }, { handlerEnabled: true })
}


export default {
  fetchModeratorAvailability,
  postModeratorAvailability,
  fetchTimeSlotsForModerator,
  putModeratorAvailability,
  deleteModeratorAvailability,
  fetchModeratorsForTimeSlot,
  fetchPossibleModeratorsForTimeSlot,
  postModeratorsForConference,
  deleteModeratorFromConference,
  fetchModeratorAvailabilityForPM,
  fetchTimeSlotsForPM,
  //  fetchObserversForTimeSlot,
  // putObservers,
  //  fetchAvailabilityAndTimeslotsForProject,
  fetchAvailabilityForProject,
  fetchConferenceLinkByTimeslotId,
  deleteModeratorFromProject,
  fetchModeratorImportedAvailability,
  unlinkImportModerator,
  updateGoogleSpreadSheet,
  fetchImportAvailabilityStatus,
  fetchProjectAvailability,
  saveProjectAvailability
}
